export function updateQueryString(
	station_id: string | null,
	from_date: string | null,
	to_date: string | null,
): void {
	const urlParams = new URLSearchParams(window.location.search);
	if (station_id) urlParams.set("station_id", station_id);
	if (from_date) urlParams.set("from_date", from_date);
	if (to_date) urlParams.set("to_date", to_date);
	const newUrl = `${window.location.protocol}//${window.location.host}${
		window.location.pathname
	}?${urlParams.toString()}`;
	window.history.pushState({ path: newUrl }, "", newUrl);
}

export function getDateTime(timestamp: number): Date {
	return new Date(631152000 * 1000 + timestamp * 1000);
}

export function updateButtons(stationId: string): void {
	const list = document.getElementById("stationNavButtons");
	if (!list) {
		console.error(`No "stationNavButtons" list defined`);
		return;
	}
	const links = list.getElementsByTagName("a");
	for (let i = 0; i < links.length; i++) {
		links[i].classList.remove("active");
	}
	const activeButton = document.getElementById(`${stationId}Nav`);
	if (activeButton) activeButton.classList.add("active");
}
export function setXAxisRange(
	divId: string,
	startDate: string,
	endDateString: string | null | undefined,
): void {
	const endDate = endDateString ? new Date(endDateString) : new Date();
	const range = [new Date(startDate), endDate] as [Date, Date];
	const layoutUpdate = {
		"xaxis.range": range,
	};
	Plotly.relayout(divId, layoutUpdate).catch((e) => console.error(e));
}
